import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';

@Component({
  selector: 'nz-explain-wrapper',
  templateUrl: './nz-explain-wrapper.component.html',
  styleUrls: ['./nz-explain-wrapper.component.scss']
})
export class NzExplainWrapperComponent implements OnInit {

  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService, 
    private lookupDataService: LookupDataService) { }

  ngOnInit() {
    console.log(this.hostFormControl)
  }
  formControl


  /**
   * ComponentSpecific Inputs, Outputs and Functions
   *  
   */
  @Output() componentOutput = new EventEmitter<any>();

  @Input() formName: string;
  @Input() hostFormControl: any;

  EmitComponentOutput(data) {
    this.componentOutput.emit(data)
  }
  getParentComponent(): Component {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
 } catch{}
  }
  getParentComponentName(): Component {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
 } catch{}
  }

}
